$(document).ready(function(){
  setInterval(function(){
    if( $('[snippet="cart-upsell"]').length > 0 ){
      if( $('.cart-upsell-main').hasClass('slick-initialized') ){}else{$('.cart-upsell-main').slick({dots: true,infinite: false,speed: 300,slidesToShow: 1,slidesToScroll: 1,arrows: false })}
    }
  },200)  

  $(document).on("click", ".errorshowbtn", function(){
    $('.upsell_content-outer').addClass("errormessage");
  });

  $('.MainGridwrap').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
  
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });



// setInterval(function(){  
 
//   var randomNum = Math.random() * (10 - 5) + 5;
//    var randomNumprogress = Math.random() * (100 - 25) + 25;
// randomNum = Math.floor(randomNum);
//   randomNumprogress = Math.floor(randomNumprogress);
//   var el = document.getElementById('ranNum');
//    var elem = document.getElementById("Widthpro");
//  el.innerHTML = randomNum;
 
//     if (randomNumprogress < 100) {
//       elem.style.width = randomNumprogress  + '%';
//       elem.innerHTML = randomNumprogress;
//     }
//  },3000)

  var randomNum = Math.random() * (10 - 5) + 5, randomNumprogress = randomNum*10, el = document.querySelectorAll('#ranNum'), elem = document.querySelectorAll("#Widthpro");
  randomNum = Math.floor(randomNum);
  if(el.length > 0){
    el.innerHTML = randomNum;
  }
  if(elem.length > 0){
    elem.style.width = randomNumprogress  + '%';
    elem.innerHTML = randomNumprogress;
  }

});




  


